import React, { useEffect, useState } from 'react';
import { collection, getDocs, doc, deleteDoc } from 'firebase/firestore';
import { db } from '../../../firebase';
import {KTSVG} from '../../../_metronic/helpers';

type Props = {
  className?: string;
};

export interface User {
    id: string;
    email: string;
    name: string;
    isAdmin: boolean;
    // Add more fields as needed
}

const UserTable: React.FC<Props> = ({ className }) => {
  const [users, setUsers] = useState<User[]>([]);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const usersRef = collection(db, 'users');
        const querySnapshot = await getDocs(usersRef);
        let userData: User[] = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        })) as User[];
        setUsers(userData);
      } catch (error) {
        console.error('Error fetching users:', error);
      }
    };

    fetchUsers();
  }, []);

  const deleteUser = async (id: string) => {
    if(window.confirm("Are you sure you want to delete this user?")) {
      try {
        await deleteDoc(doc(db, 'users', id));
        setUsers(users.filter(user => user.id !== id));  // remove deleted user from the state
      } catch (error) {
        console.error('Error deleting user:', error);
      }
    }
  };

  return (
    <div className={`card ${className}`}>
      <div className='card-header border-0 pt-5' style={{display: 'flex', justifyContent: 'space-between'}}>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bold fs-3 mb-1'>Users</span>
          <span className='text-muted mt-1 fw-semibold fs-7'>Showing all users</span>
        </h3>
      </div>

      <div className='card-body py-3'>
        <div className='table-responsive'>
          <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
            <thead>
              <tr className='fw-bold text-muted'>
                <th className='min-w-150px'>User Name</th>
                <th className='min-w-140px'>Email</th>
                
                <th className='min-w-100px text-end'>Actions</th>
                {/* Add more columns as needed */}
              </tr>
            </thead>
            <tbody>
              {users.map((user) => (
                <tr key={user.id}>
                  <td>{user.name}</td>
                  <td>{user.email}</td>
                  
                  <td>
                    <div className='d-flex justify-content-end'>
                      <button className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'>
                        <KTSVG path='/media/icons/duotune/general/gen004.svg' className='svg-icon-3' />
                      </button>
                      <button onClick={() => deleteUser(user.id)} className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'>
                        <KTSVG path='/media/icons/duotune/general/gen027.svg' className='svg-icon-3' />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export { UserTable };
